module.exports = __webpack_public_path__ + "img/produto-modal.24021be8.svg";